<div class="e-action-bar" aria-live="polite">
    <ng-container *ngIf="showCancelButton">
        <button mat-button color="secondary" (click)="cancelClicked()" [disabled]="!disableApplyButton">Cancel</button>
    </ng-container>
    <ng-container *ngIf="showApplyButton">
        <button mat-button color="primary" (click)="applyClicked()" [disabled]="!disableApplyButton">{{ applyButtonText }}</button>
    </ng-container>
    <ng-container *ngIf="showBackButton">
        <button mat-button color="secondary" (click)="backClicked()">
            <i class="fa-regular fa-arrow-left"></i>Back
        </button>
    </ng-container>
    <ng-container *ngIf="!nextButtonDisabled()">
        <div (mouseenter)="nextHover($event)" (mouseleave)="nextHover($event)">
            <button
                mat-button
                color="primary"
                (click)="nextClicked()"
                [disabled]="nextButtonDisabled() ? 'disabled' : null"
                [innerHTML]="showCompleteButton ? 'Complete' : nextButtonText + nextButtonIconHtml"></button>
        </div>
    </ng-container>
</div>
